export const ConsumerAddressViewErrorMessages = {
  errorMessage: {
    id: 'Pages.ConsumerAddress.View.error.message',
    description: 'Error message for consumer address view',
  },
}
